import { useCompassWebSecurityGetPasswordRulesQuery } from "./get-password-rules.v5.generated";
export var useFetchPasswordRules = function useFetchPasswordRules(_ref) {
  var organizationId = _ref.organizationId;
  var _useCompassWebSecurit = useCompassWebSecurityGetPasswordRulesQuery({
      variables: {
        input: {
          centralized_organization_id: organizationId
        }
      },
      context: {
        clientName: 'v5'
      }
    }),
    data = _useCompassWebSecurit.data,
    loading = _useCompassWebSecurit.loading,
    error = _useCompassWebSecurit.error;
  var payload = data === null || data === void 0 ? void 0 : data.security_policies.password_policy;
  return {
    rules: (payload === null || payload === void 0 ? void 0 : payload.__typename) === 'GetPasswordPolicyPayload' ? payload.policy.rules : [],
    loading: loading,
    error: error
  };
};